import { Link } from "react-router-dom"
import { TableUIRenderCellProps, Typography } from "matsuri-ui"
import { PlaceName } from "./type"

export const PlacementNameCell = ({
    cell: { value },
    isAssignedCompany = false
}: TableUIRenderCellProps<{ placeName: PlaceName }, PlaceName> & {
    isAssignedCompany?: boolean
}) => {
    return value.placementType === "commonArea" ? (
        <Typography>{value.commonAreaName}</Typography>
    ) : isAssignedCompany ? (
        <Typography>{value.listingName}</Typography>
    ) : (
        <Link to={`/listings/${value.listingId}`}>{value.listingName}</Link>
    )
}
